export default {
  // global theme for the app
  globalTheme: 'light', // light | dark

  // dark theme colors
  dark: {
    textbase: '#edf0f2',
    background: '#05090c',
    surface: '#111b27',
    primary: '#0096c7',
    secondary: '#a5d6a7',
    accent: '#59bbbb',
    error: '#FF5252',
    info: '#2196F3',
    success: '#2E7D32',
    warning: '#FFC107'
  },

  // light theme colors
  light: {
    //textbase: '#222222',
    textbase: '#26a69a',
    background: '#ffffff',
    surface: '#f2f5f8',
    primary: '#2E7D32',
    secondary: '#a5d6a7',
    accent: '#59bbbb',
    error: '#ef476f',
    info: '#2196F3',
    success: '#2E7D32',
    warning: '#ffd166'
  }
}
